export const SERVICE_CONTACTS = [
  {
    region: 'US',
    type: 'email',
    value: 'Labelcheap@gmail.com'
  },
  {
    region: 'CN',
    type: 'wechat',
    value: 'labelcheap'
  }
]

export const WELCOME_CONTENT = {
  zh: {
    lang: 'EN',
    languageLabel: 'Switch to English',
    login: '立即下单',
    heroBefore: '正规单源，',
    heroAccent: '一分钟',
    heroAfter: '拿到你的 label。',
    heroIntro: '不做科技单，不跑水，不混单。价格每周出账，每一笔扣费都可回溯；50+ 美国快递账号一键比价，从下单到面单，60 秒。',
    startOrder: '开始创建运单 →',
    fraudAlert: '假单请拨 110',
    tags: [
      'VERIFIED WAYBILL',
      'TRACKABLE END-TO-END',
      'NO MIX · NO REBILL'
    ],
    highlights: [
      {
        value: '100%*',
        unit: '',
        lines: [
          '官方正规账号出单',
          '拒接科技单 / 跑水单'
        ]
      },
      {
        value: '50+',
        unit: '账号',
        lines: [
          '美国主流快递账号池',
          '同票一键比价'
        ]
      },
      {
        value: '1',
        unit: '分钟',
        lines: [
          '下单到 label 出图',
          '含地址校验'
        ]
      },
      {
        value: '7',
        unit: '天',
        lines: [
          '固定周期出账单',
          '逐笔明细可导出'
        ]
      }
    ],
    disclaimer: '* 指平台所出运单均来自已签约的合规承运账号，非自营承诺口径，具体以承运商实际揽收与账单为准。',
    featuresTitle: '为什么选择 LabelCheap',
    features: [
      {
        icon: '🛡️',
        before: '官方正规运单，',
        accent: '零容忍',
        after: '假单',
        intro: '非科技单，非跑水单，绝对不混单。我们坚持使用签约合规账号出单，保障你的包裹端到端可追踪。',
        points: [
          {
            text: '100% 官方正规渠道，拒接灰色单源'
          },
          {
            text: '绝不混单，每一票独立可追溯'
          },
          {
            text: '如果在我们网站做到假单，请直接拨打 110',
            alert: true
          }
        ]
      },
      {
        icon: '🧾',
        before: '收费明确，价格',
        accent: '清晰',
        after: '',
        intro: '告别糊涂账。所有扣费清晰合理，有迹可查，让你每周都能掌握精准的物流成本。',
        points: [
          {
            text: '每周固定出具账单，周期稳定'
          },
          {
            text: '所有扣费项透明，无隐藏收费'
          },
          {
            text: '逐笔明细支持导出，对账极简'
          }
        ]
      },
      {
        icon: '⚡',
        before: '50+ 账号',
        accent: '一键比价',
        after: '',
        intro: '美国市场主流快递我们都有账号，打造强大的账号池，给你更多选择与最优价格。',
        points: [
          {
            text: '覆盖美国主流快递网络（UPS/USPS/FedEx等）'
          },
          {
            text: '同票一键对比价格，智能推荐'
          },
          {
            text: '账号池深，选择更多，抗风险能力强'
          }
        ]
      },
      {
        icon: '⏱️',
        before: '1 分钟出单，操作',
        accent: '极简',
        after: '',
        intro: '从下单到得到 Label 只需一分钟。系统含地址自动校验，简单快捷，大幅提升发货效率。',
        points: [
          {
            text: '填地址 → 比价 → 出图，全流程 60 秒'
          },
          {
            text: '内置地址校验，减少退件率'
          },
          {
            text: '界面清爽，新手也能秒上手'
          }
        ]
      }
    ],
    statementTitle: '底线声明',
    statementText: '我们不做科技单、跑水单、混单。合规是生存底线，假单请直接 110。',
    closingAfter: '拿到你的 label',
    closingIntro: '50+ 账号比价 · 每周清晰账单 · 官方合规出单',
    startShipping: '立即开始发货',
    footer: '© LabelCheap. 合规承运账号平台 | 假单举报：110 | 页面数据为示意，具体以实际承运商为准',
    contact: '联系我们',
    contactShort: '客服',
    contactHint: '开户与系统使用咨询',
    closeContact: '收起联系方式',
    us: '美国客服',
    cn: '中国大陆客服',
    contactType: { email: '邮箱', wechat: '微信号' },
    copyContact: { email: '复制邮箱', wechat: '复制微信号' },
    copied: '已复制',
    copyFailed: '复制失败，请手动选择联系方式',
    top: '返回顶部'
  },
  en: {
    lang: '中文',
    languageLabel: '切换到中文',
    login: 'Order now',
    heroBefore: 'Legitimate labels, ',
    heroAccent: 'one minute',
    heroAfter: ' to get your label.',
    heroIntro: 'No fraudulent, unpaid or mixed labels. Weekly billing keeps every charge traceable. Compare 50+ U.S. carrier accounts, from order to label in 60 seconds.',
    startOrder: 'Create a shipment →',
    fraudAlert: 'Fraudulent labels? Call 911',
    tags: [
      'VERIFIED WAYBILL',
      'TRACKABLE END-TO-END',
      'NO MIX · NO REBILL'
    ],
    highlights: [
      {
        value: '100%*',
        unit: '',
        lines: [
          'Legitimate carrier accounts',
          'No fraudulent or unpaid labels'
        ]
      },
      {
        value: '50+',
        unit: 'accounts',
        lines: [
          'Major U.S. carrier account pool',
          'Compare the same shipment'
        ]
      },
      {
        value: '1',
        unit: 'minute',
        lines: [
          'From order to shipping label',
          'Address validation included'
        ]
      },
      {
        value: '7',
        unit: 'days',
        lines: [
          'Regular billing cycle',
          'Export itemized charge records'
        ]
      }
    ],
    disclaimer: '* Labels are issued through contracted, compliant carrier accounts. This is not a self-operated carrier guarantee; actual collection and bills follow the carrier.',
    featuresTitle: 'Why choose LabelCheap',
    features: [
      {
        icon: '🛡️',
        before: 'Legitimate labels. ',
        accent: 'Zero tolerance',
        after: ' for fraud.',
        intro: 'No fraudulent, unpaid or mixed labels. We use contracted, compliant carrier accounts to keep your shipments trackable end to end.',
        points: [
          {
            text: '100% legitimate channels; no questionable label sources'
          },
          {
            text: 'No mixed labels; each shipment is independently traceable'
          },
          {
            text: 'If you receive a fraudulent label from our site, call 911',
            alert: true
          }
        ]
      },
      {
        icon: '🧾',
        before: 'Clear charges. ',
        accent: 'Transparent prices.',
        after: '',
        intro: 'No more confusing bills. Every charge is clear, reasonable and traceable, so you can understand shipping costs each week.',
        points: [
          {
            text: 'Weekly bills on a regular schedule'
          },
          {
            text: 'Transparent charge items, with no hidden fees'
          },
          {
            text: 'Export itemized records for simple reconciliation'
          }
        ]
      },
      {
        icon: '⚡',
        before: '50+ accounts. ',
        accent: 'Compare in one click.',
        after: '',
        intro: 'Our account pool covers major U.S. carriers, giving you more options and competitive prices.',
        points: [
          {
            text: 'Major U.S. networks, including UPS, USPS and FedEx'
          },
          {
            text: 'Compare the same shipment with smart recommendations'
          },
          {
            text: 'A deep account pool for more choice and resilience'
          }
        ]
      },
      {
        icon: '⏱️',
        before: 'One-minute labels. ',
        accent: 'Simple steps.',
        after: '',
        intro: 'From ordering to your label in one minute. Built-in address validation keeps the process simple and improves shipping efficiency.',
        points: [
          {
            text: 'Enter address → compare → get a label, all in 60 seconds'
          },
          {
            text: 'Built-in address validation helps reduce returns'
          },
          {
            text: 'A clean interface that is easy for new users'
          }
        ]
      }
    ],
    statementTitle: 'Our standard',
    statementText: 'No fraudulent, unpaid or mixed labels. Compliance is our baseline. For fraudulent labels, call 911.',
    closingAfter: ' to get your label',
    closingIntro: 'Compare 50+ accounts · Clear weekly bills · Compliant carrier labels',
    startShipping: 'Start shipping now',
    footer: '© LabelCheap. Compliant carrier account platform | Fraud reporting: 911 | Page figures are illustrative; actual carrier information applies.',
    contact: 'Contact us',
    contactShort: 'Help',
    contactHint: 'Accounts and workspace support',
    closeContact: 'Close contact details',
    us: 'United States',
    cn: 'Mainland China',
    contactType: { email: 'Email', wechat: 'WeChat ID' },
    copyContact: { email: 'Copy email', wechat: 'Copy WeChat ID' },
    copied: 'Copied',
    copyFailed: 'Copy failed. Please select the contact details manually.',
    top: 'Back to top'
  }
}
